class FixedBar extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    if (!this.externalEls?.form?.exists) return

    this.observer = new IntersectionObserver(this.onEntry.bind(this), {
      rootMargin: '0px',
      threshold: 0,
    })

    this.observer.observe(this.externalEls.form.element)

    this.onScrollOrResize = this.updateVisibility.bind(this)
    window.addEventListener('resize', this.onScrollOrResize)
    window.addEventListener('scroll', this.onScrollOrResize)
  }

  disconnectedCallback () {
    super.disconnectedCallback()

    this.observer?.disconnect()

    window.removeEventListener('resize', this.onScrollOrResize)
    window.removeEventListener('scroll', this.onScrollOrResize)
  }

  onEntry ([entry]) {
    this.formIntersecting = entry.isIntersecting
    this.updateVisibility()
  }

  updateVisibility () {
    const wrapper = this.externalEls.wrapper?.element
    const form = this.externalEls.form?.element
    const viewportHeight = window.innerHeight

    let shouldShow = true

    // Hide if form is in view
    if (this.formIntersecting) shouldShow = false

    // Hide if form is still below the fold (not yet reached)
    if (form) {
      const formRect = form.getBoundingClientRect()
      if (formRect.top > viewportHeight) {
        shouldShow = false
      }
    }

    // Hide if wrapper bottom has scrolled into view
    if (wrapper) {
      const wrapperRect = wrapper.getBoundingClientRect()
      if (wrapperRect.bottom <= viewportHeight) {
        shouldShow = false
      }
    }

    this.classList.toggle('prd-Detail_FixedBar-hidden', !shouldShow)
  }
}

if (!customElements.get('fixed-bar')) {
  customElements.define('fixed-bar', FixedBar)
}
